<template>
    <detail :id="id" verify></detail>
</template>

<script>
    import detail from './moments_apply_detail.vue'

    export default {
        name: 'moments_apply_verify',

        components: {
            detail
        },

        props: {
            id: String
        }
    }
</script>